import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { fetchSelectedCalendar, submitSelectedCalendar } from '../../redux/actions/settingActions';
import { useSelector } from 'react-redux';
import { CiSettings } from "react-icons/ci";

const SettingCalendarSelect = (props) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedData = useSelector((state) => state.setting.fetchSelectedCalendar);

  useEffect(() => {
    dispatch(fetchSelectedCalendar(props.authToken));
  }, [])
  
  const handleActivate = (data) =>{
    if(selectedData && selectedData?.default !== data){
      dispatch(submitSelectedCalendar(props.authToken,data));
    }
  }

  return (
    <>
    <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
        <div className="text-lg leading-7 font-[500] my-auto">Select Calendar</div>
        <div className="flex items-center">
          <button
            type="button"
            className="mr-4 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] px-3 py-2 text-sm font-semibold text-white shadow-sm"
          >
            Save Changes
          </button>
        </div>
      </div>
      <div className="max-sm:h-full h-[73vh] listing mt-8">
      <div className="h-[73vh] max-sm:h-[80vh] listing overflow-auto px-6 sm:px-8 lg:px-10">
        <div className="grid grid-cols-8 gap-4">
        <div className='col-span-8 sm:col-span-2 bg-white shadow-md py-6 px-6 rounded-md'>
          <div className='flex flex-col'>
            <div className='flex justify-between'>
            <div className='text-base font-[600] my-auto'>Zoi Calendar</div>
            {selectedData?.ZOI_CALENDAR && <div className={`${selectedData?.default === "ZOI_CALENDAR" ? "text-[#49BCD2] rounded-md bg-blue-100 px-2 py-1 text-xs font-medium ":"rounded-md bg-blue-100 px-2 py-1 text-xs font-medium text-blue-700"} text-sm cursor-pointer`} onClick={()=>{handleActivate("ZOI_CALENDAR")}}>{selectedData?.default === "ZOI_CALENDAR" ?"Activated":selectedData?.ZOI_CALENDAR &&"Activate"}</div>}
            </div>
            <div className='flex justify-between mt-8'>
            <div onClick={()=>{navigate("/Setting/connect");}} className={`text-sm cursor-pointer ${ selectedData?.ZOI_CALENDAR ? "text-red-500":""}`}>{selectedData?.ZOI_CALENDAR ? "Disconnect" : "Connect"}</div>
            <div onClick={()=>{navigate("/Setting/connect");}} className='cursor-pointer text-base font-[600]  text-black text-xl my-auto flex rounded-full'><CiSettings /></div>

            </div>
          </div>
          </div>
        <div className='col-span-8 sm:col-span-2 bg-white shadow-md py-6 px-6 rounded-md'>
          <div className='flex flex-col'>
            <div className='flex justify-between'>
            <div className='text-base font-[600] my-auto'>Calendly</div>
            {selectedData?.CALENDLY && <div className={`${selectedData?.default === "CALENDLY" ? "text-[#49BCD2] rounded-md bg-blue-100 px-2 py-1 text-xs font-medium":"rounded-md bg-blue-100 px-2 py-1 text-xs font-medium text-blue-700"} text-sm cursor-pointer`} onClick={()=>{handleActivate("CALENDLY")}}>{selectedData?.default === "CALENDLY" ?"Activated":selectedData?.CALENDLY && "Activate"}</div>}
            </div>
            <div className='flex justify-between mt-8'>
            <div onClick={()=>{navigate("/Setting/calendly");}} className={`text-sm cursor-pointer ${ selectedData?.CALENDLY ? "text-red-500":""}`}>{selectedData?.CALENDLY ? "Disconnect" : "Connect"}</div>
              <div onClick={()=>{navigate("/Setting/calendly");}} className='cursor-pointer text-base font-[600]  text-black text-xl my-auto flex rounded-full'><CiSettings /></div>
            </div>
          </div>
          </div>
        
        </div>
      </div>
      </div>
    </>
  )
}

export default SettingCalendarSelect